import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import buttons from 'style/buttons.module.scss';
import Switcher from 'components/common/switcher/customSwitcher';
import Title from 'components/common/Title/index';
import getMapTemplateImage from 'utils/helpers/switchTemplate';
import { IScholars, IScholarsRequestData, MapType } from 'types';
import { connect, useDispatch } from 'react-redux';
import { IRootState } from 'store';
import { editScholar, getScholar } from 'actions/scholars';
import { defaultMapTemplate } from 'utils/constants/map';
import templateStyle from './switchTemplate.module.scss';

const mapStateToProps = (state: IRootState) => ({
  activeScholarId: state.users.userData?.activeScholarId,
  scholar: state.scholars.scholar,
});

interface SwitchTemplateProps {
  isSwitcherDisabled?: boolean;
  kidName?: string;
  activeScholarId: number | undefined;
  scholar: IScholars | null;
}
const SwitchTemplate: React.FC<SwitchTemplateProps> = ({
  isSwitcherDisabled,
  kidName,
  activeScholarId,
  scholar,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const mapType = scholar?.settings?.mapType;
  const [switcherCheck, setSwitcherCheck] = useState(
    mapType !== MapType.Linear
  );

  useEffect(() => {
    if (activeScholarId) {
      dispatch(getScholar(activeScholarId));
    }
  }, [activeScholarId, dispatch]);

  const handleBack = () => {
    if (isSwitcherDisabled) {
      history.push(`/onboarding/timetable/resources`);
    } else {
      history.push(`/onboarding/choose-map/`);
    }
  };

  const handleNext = () => {
    if (isSwitcherDisabled) {
      history.push(`/onboarding/timetable/review-home`);
    } else {
      history.push(`/onboarding/timetable`);
    }
  };

  const changeMapType = useCallback(
    async (type: MapType) => {
      if (!activeScholarId) {
        return;
      }

      const editData: Partial<IScholarsRequestData> = {
        id: activeScholarId,
        settings: {
          permissionToEditResources: !!scholar?.settings
            ?.permissionToEditResources,
          permissionToEditTimetable: !!scholar?.settings
            ?.permissionToEditTimetable,
          mapTemplate: scholar?.settings?.mapTemplate || defaultMapTemplate,
          mapType: type,
        },
      };

      await dispatch(editScholar(activeScholarId, editData));
    },
    [activeScholarId, scholar, dispatch]
  );

  const setMapType = useCallback(
    (isActive: boolean) => {
      if (!isActive) {
        setSwitcherCheck(false);
        changeMapType(MapType.Linear);
      } else {
        changeMapType(MapType.Static);
        setSwitcherCheck(true);
      }
    },
    [changeMapType]
  );

  const StaticTemplate = getMapTemplateImage(
    scholar?.settings?.mapTemplate || defaultMapTemplate,
    MapType.Static
  );
  const LinearTemplate = getMapTemplateImage(
    scholar?.settings?.mapTemplate || defaultMapTemplate,
    MapType.Linear
  );

  return (
    <div className={templateStyle.contentContainer}>
      {/* <SideBar /> */}
      <div className={templateStyle.screenContainer}>
        <Title>
          {kidName
            ? `${kidName} Learning Workflow Map`
            : 'Toggle below to select Linear or Static map'}
        </Title>
        {switcherCheck ? (
          <img src={StaticTemplate} alt="img" />
        ) : (
          <img src={LinearTemplate} alt="img" />
        )}
      </div>
      <div
        className={templateStyle.buttonContainer}
        style={isSwitcherDisabled ? { gridTemplateColumns: '1fr 1fr' } : {}}
      >
        <button
          className={`${buttons.buttonOutline} ${templateStyle.back}`}
          type="button"
          onClick={handleBack}
        >
          Back
        </button>
        {!isSwitcherDisabled && (
          <div className={templateStyle.switcherWrapper}>
            <Switcher
              onChange={setMapType}
              checked={switcherCheck}
              offName="Linear"
              onName="Static"
            />
          </div>
        )}
        <button
          className={`${buttons.buttomPrimary} ${templateStyle.choose}`}
          type="button"
          onClick={handleNext}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default connect(mapStateToProps)(SwitchTemplate);
